const CF_DOMAIN = "https://db8yv5ecmiefg.cloudfront.net";
export function rewriteToCloudFront(originalUrl) {
  // example for "https://yourbucket.s3.amazonaws.com/uploads/mypicture.jpg"
  // parse out "uploads/mypicture.jpg"
  const s3Key = originalUrl.replace(/^.*\.com\//, "");
  const rewritten = s3Key.replace(/\.png(\?.*)?$/i, ".webp$1"); // convert .png to .webp
  return `${CF_DOMAIN}/${rewritten}`;
}

/**
 * Decide what avatar URL an AI profile should use.
 *   • if `imageUrl` exists → honour it
 *   • else, if the name contains "Tweeting.AI" (case‑insensitive)
 *           → fall back to the bundled icon
 *   • else → return `null` so the <Avatar> shows initials
 */
export function avatarForProfile(profile) {
  if (!profile) return null;
  if (profile.imageUrl) return rewriteToCloudFront(profile.imageUrl);

  const isTweetingAI = /tweeting\.ai/i.test(profile.name);
  return isTweetingAI ? "/logo.ico" : null; // <── your icon here
}
